import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import ObjectUtils from '../../../modules/ObjectUtils';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';

class PayableIntegrationServicePayableDetails extends React.Component {
  getUniqueId = (str) => {
    return ObjectUtils.formatStringAsJSONArray(str).value;
  };

  formatTransactions(paymentTransactions = []) {
    return paymentTransactions.map((value) => {
      const ref = { ...value, };
      ref.paymentAmount = value.paymentAmount ?? '';
      ref.paymentDate = value.paymentDate ? new Date(value.paymentDate).toLocaleString() : '';
      return ref;
    });
  }

  render() {
    const { payable, } = this.props;

    const payableItems = VerticalLabelList.toList({
      'Payable ID': payable.id,
      'Unique ID': payable.uniqueIdentifier.value ? payable.uniqueIdentifier.value : this.getUniqueId(payable.uniqueIdentifier),
      'File ID': payable.fileId,
      Paid: payable.paid,
      'Amount Due': payable.currentAmountDue,
      Active: payable.active,
      Deleted: payable.deleted,
      'Original Amount Due': payable.originalAmountDue,
    });

    const searchableData = ObjectUtils.formatStringAsJSONArray(payable.searchableData);
    const searchableDataItems = VerticalLabelList.toList(searchableData.reduce((prev, curr) => {
       
      prev[curr.key] = curr.value;
      return prev;
    }, {}));

    const unsearchableData = ObjectUtils.formatStringAsJSONArray(payable.unsearchableData);
    const unsearchableDataItems = VerticalLabelList.toList(unsearchableData.reduce((prev, curr) => {
       
      prev[curr.key] = curr.value;
      return prev;
    }, {}));

    const txnData = ObjectUtils.formatStringAsJSONArray(payable.paymentTransactions);
    const transactionModel = Grid.toModelFromList(txnData, {
      headerFormatter: value => _.startCase(value.header),
    });

    return (
        <>
          <FieldSet title="Payable Summary" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={payableItems} />
          </FieldSet>
          <FieldSet title="Searchable Data" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={searchableDataItems} />
          </FieldSet>
          <FieldSet title="Unsearchable Data" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={unsearchableDataItems} />
          </FieldSet>
          <FieldSet title="Payment Transactions">
            <Grid
              headers={transactionModel.headers}
              rows={transactionModel.format(this.formatTransactions(txnData))}
            />
          </FieldSet>
        </>
    );
  }
}

PayableIntegrationServicePayableDetails.defaultProps = {};

PayableIntegrationServicePayableDetails.propTypes = {
  payable: PropTypes.instanceOf(Object).isRequired,
};

export default PayableIntegrationServicePayableDetails;
